class ProductBreadcrumbs extends window.BAO.CustomElement() {
  connectedCallback () {
    if (this.dataset.genderLock === 'm' || this.dataset.genderLock === 'f') {
      return
    }

    this.els.link.elements.forEach((link, i) => {
      if (link.dataset.genderSpecific === 'true') {
        const url = new URL(window.location)
        if (url.searchParams.has('gender')) {
          if (url.searchParams.get('gender') === 'female') {
            if (i === 0) {
              link.querySelector('span').innerText = 'WOMEN'
            }

            if (link.dataset.genderSpecificValid === 'm') {
              link.parentElement.remove()
            }

            link.href = link.href.replace('/men', '/women')
          } else if (url.searchParams.get('gender') === 'male') {
            if (i === 0) {
              link.querySelector('span').innerText = 'MEN'
            }

            if (link.dataset.genderSpecificValid === 'f') {
              link.parentElement.remove()
            }

            link.href = link.href.replace('/women', '/men')
          }
        }
      }
    })
  }
}

if (!customElements.get('product-breadcrumbs')) {
  customElements.define('product-breadcrumbs', ProductBreadcrumbs)
}
